import { defineComponent as Q, useSlots as U, ref as p, toRef as Z, watch as ee, computed as t, useAttrs as te, onMounted as ae, createElementBlock as h, openBlock as b, createElementVNode as l, createCommentVNode as y, normalizeClass as s, mergeProps as re, toHandlers as oe, unref as le, toDisplayString as C, renderSlot as se, normalizeProps as ie, guardReactiveProps as ne, nextTick as ue } from "vue";
import { watchThrottled as de } from "@vueuse/core";
import { useNativeInput as ce } from "../../composables/useNativeInput.js";
import { isEmpty as N } from "../../utils/isEmpty.js";
import { requestAnimationFrame as fe } from "../../utils/requestAnimationFrame.js";
import { tw as e } from "../../utils/tailwind.js";
const ve = { class: "relative" }, me = { class: "body-1 flex w-full items-center" }, pe = ["id", "disabled", "required", "rows", "value"], he = ["for"], be = ["id"], A = 24, R = 4, Ne = /* @__PURE__ */ Q({
  name: "RevInputTextarea",
  inheritAttrs: !1,
  __name: "InputTextarea",
  props: {
    description: { default: "" },
    disabled: { type: Boolean, default: !1 },
    id: {},
    label: {},
    modelValue: {},
    rows: { default: 1 },
    maxRows: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid"],
  setup(P, { emit: H }) {
    const a = P, L = U(), d = H, c = p(a.rows), f = p(null), q = p(null), i = p(null), n = Z(a, "modelValue"), T = (r) => {
      i.value && f.value && f.value.setAttribute("data-cloned-val", r);
    }, u = ce(i, n, {
      onInput: (r) => {
        d("update:modelValue", r.target.value), T(r.target.value), d("input", r);
      }
    });
    ee(
      u.invalid,
      (r, m) => {
        r ? d("invalid", i.value?.validity) : m && d("valid");
      },
      { immediate: !0 }
    );
    const w = t(() => Number(te().maxlength)), x = t(
      () => Number.isInteger(w.value) && w.value > 0
    ), I = t(() => x.value ? w.value - (a.modelValue !== void 0 ? a.modelValue : "").toString().length : Number.POSITIVE_INFINITY), V = t(() => x.value && L.count), E = t(
      () => x.value && I.value < 0
    ), B = t(() => !N(a.description)), g = t(() => !N(a.error)), O = t(
      () => u.touched.value && u.invalid.value
    ), S = t(() => B.value || g.value), z = t(() => V.value || S.value), o = t(
      () => E.value || O.value || g.value
    ), D = t(() => g.value ? a.error : a.description), M = t(() => {
      if (o.value)
        return `${a.id}_error`;
    }), W = t(
      () => typeof a.modelValue == "string" ? !N(a.modelValue) : !(typeof a.modelValue > "u")
    ), v = t(
      () => u.focused.value || W.value
    ), $ = t(() => [
      e`
    not-supports-[line-clamp-1]:after:max-h-[calc(var(--textarea-rows)*1.5em_+_30px)]
    after:line-clamp-[--textarea-rows]
  `,
      c.value === 1 ? e`after:min-h-[calc(var(--textarea-rows)*1.5em_+_24px)]` : e`after:min-h-[calc(var(--textarea-rows)*1.5em_+_28px)]`,
      e`
    w-full
    after:invisible after:overflow-hidden after:whitespace-pre-wrap after:border
    after:px-12 after:text-inherit after:content-[attr(data-cloned-val)_'_']
    after:[grid-area:1/1/2/2]
  `,
      // same as TEXTAREA_PADDING_BOTTOM
      v.value && e`after:pb-4 after:pt-24`,
      !a.disabled && !o.value && e`cursor-text`
    ]), F = t(() => [
      $.value,
      e`peer group grid w-full`
    ]), G = t(() => [
      e`rounded-sm relative min-h-48 border border-solid [grid-area:1/1/2/2]`,
      !a.disabled && e`group-hover:bg-static-default-low-hover group-has-[:hover]:bg-static-default-low-hover`,
      e`has-[:disabled]:bg-static-default-low-disabled has-[:disabled]:border-action-default-low-disabled`,
      !o.value && e`bg-static-default-low border-action-default-low focus-within:border-action-default-low-focus focus-within:outline-default-low`,
      o.value && e`border-action-danger-low focus-within:border-action-danger-low-focus focus-within:outline-danger-low`
    ]), X = t(() => [
      e`rounded-sm input-normalize relative block w-full min-w-0 resize-none overflow-auto`,
      e`bg-transparent px-12 text-inherit outline-none`,
      e`disabled:text-action-default-hi-disabled`,
      // See TEXTAREA_PADDING_BOTTOM
      v.value && e`top-24 min-h-24 pb-4`,
      !v.value && e`min-h-48`,
      !o.value && e`text-action-default-hi`,
      e`motion-safe:transition-colors motion-safe:duration-200`
    ]), Y = t(() => [
      e`absolute inset-x-0 max-w-full -translate-y-1/2 truncate px-12`,
      e`peer peer-has-[:disabled]:text-action-default-hi-disabled`,
      v.value ? e`text-static-default-low caption top-1 transform-none pt-8` : e`text-action-default-hi body-1 top-24`,
      !a.disabled && !o.value && e`cursor-text`,
      e`motion-safe:transition-all motion-safe:duration-200`
    ]), j = t(() => [
      e`body-2 mt-8 flex gap-16 motion-safe:transition-colors motion-safe:duration-200`,
      a.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]), J = t(() => [
      e`grow whitespace-nowrap text-right`,
      !a.disabled && E.value && e`text-static-danger-hi`
    ]), K = t(
      () => !a.disabled && o.value && e`text-static-danger-hi`
    );
    function k(r) {
      c.value = Math.min(
        r || a.rows || 1,
        a.maxRows || 1 / 0
      ), fe(() => {
        f.value?.style.setProperty(
          "--textarea-rows",
          c.value.toString()
        );
      });
    }
    async function _() {
      if (!n.value) {
        k(a.rows || 1);
        return;
      }
      await ue();
      const m = ((i.value?.scrollHeight || A + R) - R) / A;
      k(m);
    }
    return de(
      n,
      () => {
        _();
      },
      {
        immediate: !0,
        // post means it happens after the DOM has been updated
        flush: "post",
        throttle: 200
      }
    ), ae(() => {
      T(String(n.value || "")), _();
    }), (r, m) => (b(), h("div", null, [
      l("div", ve, [
        l("div", me, [
          l("div", {
            ref_key: "textareaContainer",
            ref: f,
            class: s(F.value),
            "data-cloned-val": ""
          }, [
            l("div", {
              ref_key: "borderWrapper",
              ref: q,
              class: s(G.value)
            }, [
              l("textarea", re(r.$attrs, {
                id: r.id,
                ref_key: "textarea",
                ref: i,
                class: X.value,
                disabled: r.disabled,
                required: r.required,
                rows: c.value,
                value: n.value
              }, oe(le(u).listeners, !0), { onClick: _ }), null, 16, pe)
            ], 2)
          ], 2),
          l("label", {
            class: s(Y.value),
            for: r.id
          }, C(r.label) + C(r.required ? " *" : ""), 11, he)
        ])
      ]),
      z.value ? (b(), h("p", {
        key: 0,
        class: s(j.value)
      }, [
        S.value ? (b(), h("span", {
          key: 0,
          id: M.value,
          class: s(K.value)
        }, C(D.value), 11, be)) : y("", !0),
        V.value ? (b(), h("span", {
          key: 1,
          class: s(J.value)
        }, [
          se(r.$slots, "count", ie(ne({ count: I.value })))
        ], 2)) : y("", !0)
      ], 2)) : y("", !0)
    ]));
  }
});
export {
  Ne as default
};
